<!--
  - Copyright (c) 2021 LNBIG.com
  - All rights reserved.
  -->
<!-- TODO -->
<template>
  <div>
    <v-dialog v-model="shareQrCode">
      <v-container fluid>
        <v-card>
          <v-card-title>Please scan</v-card-title>
          <v-card-text class="text-center">
            <lnbig-qr-code
              :size="sizeQrCode"
              :level="levelQrCode"
              mode="Byte"
              :value="pageUrl"
            />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              text
              @click="shareQrCode = false"
            >Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>
    <v-speed-dial
      v-model="dialShare"
      fixed
      right
      bottom
      direction="top"
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn fab bottom small color="pink" x-large dark>
          <v-fab-transition>
            <v-icon key="close" v-if="dialShare">mdi-close</v-icon>
            <v-icon key="share" v-else>mdi-share-variant</v-icon>
          </v-fab-transition>
        </v-btn>
      </template>
      <v-btn
        dark
        fab
        bottom
        color="#26A5E4"
        :href="`https://t.me/share/url?url=${escapedPageUrl}&text=${escapedPageTitle}`"
        target="_blank"
      >
        <v-icon>$telegram</v-icon>
      </v-btn>
      <v-btn
        dark
        fab
        bottom
        color="#25D366"
        :href="`https://wa.me/?text=${escapedPageText}`"
        target="_blank"
      >
        <v-icon>$whatsapp</v-icon>
      </v-btn>
      <v-btn
        dark
        fab
        bottom
        color="blue-grey"
        :href="`mailto:?subject=${escapedPageTitle}&body=${escapedPageText}`"
        target="_blank"
      >
        <v-icon>mdi-email</v-icon>
      </v-btn>
      <v-btn dark fab bottom color="blue-grey" target="_blank" @click="shareQrCode = ! shareQrCode">
        <v-icon>mdi-qrcode</v-icon>
      </v-btn>
      <v-btn
        dark
        fab
        bottom
        color="blue-grey"
        @click="copy('The URL of session', pageUrl)"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
import Copy from "@/components/Mixin/Copy";
import QrCode from "@/components/Mixin/QrCode";

export default {
  name: "ShareButton",
  mixins: [Copy, QrCode],
  props: {
    pageUrl: {
      type: String,
      default: 'No URL yet!',
    },
    pageText: {
      type: String,
      default:
        "I share with you the channel opening process at LNBiG.COM! The URL is ",
    },
    pageTitle: {
      type: String,
      default: "The channel opening process at LNBiG.COM",
    },
  },
  data() {
    return {
      dialShare: false,
      shareQrCode: false,
    };
  },
  computed: {
    escapedPageText() {
      return encodeURIComponent(this.pageText + this.pageUrl);
    },
    escapedPageTitle() {
      return encodeURIComponent(this.pageTitle);
    },
    escapedPageUrl() {
      return encodeURIComponent(this.pageUrl);
    },
  },
};
</script>

<style scoped></style>
